<template>
    <div>
        <HeaderPurchase header="ยืนยันการสร้างรายการใบสั่งซื้อ" :img_header="header_image" link_back="addpurchase"/>
        <ConfirmAdd_Purchase/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/confirmation.png'
    import HeaderPurchase from "@/components/admin/purchase/headerpurchase/HeaderPurchase.vue";
    import ConfirmAdd_Purchase from "@/components/admin/purchase/ConfirmAdd_Purchase.vue";
    export default {
        name: "ConfirmAddPurchase",
        components: {
            ConfirmAdd_Purchase,
            HeaderPurchase,
        },
        data() {
            return {
                header_image:HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
